import axios from 'axios';
import { apiUrl } from '@/constants/config';

const actions = {
    updateVerticalNavMenuWidth({ commit }, width) {
      commit('UPDATE_VERTICAL_NAV_MENU_WIDTH', width)
    },

    updateStarredPage({ commit }, payload) {
      commit('UPDATE_STARRED_PAGE', payload)
    },

    arrangeStarredPagesLimited({ commit }, list) {
      commit('ARRANGE_STARRED_PAGES_LIMITED', list)
    },
    arrangeStarredPagesMore({ commit }, list) {
      commit('ARRANGE_STARRED_PAGES_MORE', list)
    },

    toggleContentOverlay({ commit }) {
      commit('TOGGLE_CONTENT_OVERLAY')
    },
    updateTheme({ commit }, val) {
      commit('UPDATE_THEME', val)
    },

    updateUserInfo({ commit }, payload) {
      commit('UPDATE_USER_INFO', payload)
    },


    async login({ commit }, params) {
      delete axios.defaults.headers.common['Authorization'];
      return new Promise((resolve, reject) => {
        axios({
            url: `${ apiUrl }/v1/seguridad/authorize`,
            data: params,
            method: 'POST',
            headers: { 'content-type': 'application/json' },
        })
        .then(response => {
          if(response.status === 200){
            const token = response.data.access_token;
            localStorage.setItem('token', token);
            commit('auth_success', response.data);
          }
          resolve(response);
        })
        .catch(error => {
          commit('auth_error');
          localStorage.removeItem('token');
          reject(error);
        })
      });
    },


    role({ commit }) {
      return new Promise((resolve, reject) => {
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
        axios({
            url: `${ apiUrl }/v1/seguridad/userinfo`,
            method: 'GET'
        })
        .then(response => {
            if(response.status === 200){
                const roleAdmin = response.data.authorities.find(item => item === "DEFAULT-ROLES-REGIONCUSCO_RIKUQ-ADMIN");
                const roleCoord = response.data.authorities.find(item => item === "DEFAULT-ROLES-REGIONCUSCO_RIKUQ-COORDINADOR");
                const roleUser = response.data.authorities.find(item => item === "DEFAULT-ROLES-REGIONCUSCO_RIKUQ-RESPONSABLE");
                //console.log(roleAdmin);
                if(roleAdmin !== undefined){
                    commit('role_user', roleAdmin);
                } else if(roleCoord !== undefined) {
                    commit('role_user', roleCoord);
                } else if(roleUser !== undefined) {
                    commit('role_user', roleUser);
                } else {
                    commit('role_user', undefined);
                }
            }
            resolve(response);
        })
        .catch(error => {
            commit('role_error');
            if (error.response) {
                reject(error);
            } else {
                reject(new Error('ERROR_NETWORK'));
            }
        });
      });
    },

    

    logout({ commit }) {
      // Apuntar al logout
      //return new Promise((resolve, reject) => {

      return new Promise((resolve) => {
        commit('logout')
        localStorage.removeItem('token');
        resolve()
      })
    },
}

export default actions
